module.exports = __webpack_public_path__ + "static/media/Ritesh Chaudhari.18a9e87e.jpeg";